import * as moment from 'moment';
import * as React from 'react';
import { SyntheticEvent } from 'react';
import * as Util from '../util';
import { FileData } from '../client/Home';
import * as UploadCare from 'uploadcare-widget';
import { FaFileArchiveO, FaFileO, FaFilePdfO, FaFileWordO } from 'react-icons/lib/fa';
import * as $ from 'jquery';
import * as HomeClient from '../client/Home';

window['$'] = $;

const archiveMimes: RegExp[] = [
    /^application\/x-(g?tar|xz|compress|bzip2|g?zip)$/,
    /^application\/x-(7z|rar|zip)-compressed$/,
    /^application\/(zip|gzip|tar)$/
];

const wordMimes: RegExp[] = [
    /ms-?word/,
    /application\/vnd.oasis.opendocument.text/,
    /application\/vnd.openxmlformats-officedocument.wordprocessingml.document/
];

const pdfMimes: RegExp[] = [/application\/pdf/];

export const mimeToIcon = (mime: string) => {
    if (!mime) {
        return <FaFileO />;
    }
    if (archiveMimes.some(value => Boolean(mime.match(value)))) {
        return <FaFileArchiveO />;
    }
    if (wordMimes.some(value => Boolean(mime.match(value)))) {
        return <FaFileWordO />;
    }
    if (pdfMimes.some(value => Boolean(mime.match(value)))) {
        return <FaFilePdfO />;
    }
    return <FaFileO />;
};

export type key = string | (string | number)[];
export const keyToArr = (k: key) => k instanceof Array ? k : k.includes('.') ? k.split('.') : [k];

export class Form<A, B extends object> extends React.Component<A, B> {

    protected requiredStar = <span style={{color: '#8dc63f'}}>*</span>;
    protected disableAutocomplete: boolean;
    private uploadcare: any;

    error(k: key, msg: string) {
        const s = k instanceof Array ? k.join('.') : k;
        return Util.getIn(this.state, ['errors', s]) ? <span className="badge badge-danger"> {msg} </span> : '';
    }
    errorAll(msg: string) {
        return Util.trueMap((this.state as any).errors) ? <span className="badge badge-danger"> {msg} </span> : '';
    }

    assocError(k: string): B {
        const state = Util.assocIn(this.state, ['errors', k], true) as B;
        this.setState(state);
        return state;
    }

    assocState(k: key, v: any, state?: B): B {
        state = state || this.state;
        const errors = state['errors'] || {};
        delete errors[k instanceof Array ? k.join('.') : k];
        const ks = k instanceof Array ? k : k.includes('.') ? k.split('.') : [k];
        state = Util.assocIn({...(state as object), errors}, ks, v) as B;
        this.setState(state);
        return state;
    }

    toggleRadio(m: Set<string>, area: string) {
        if (m.has(area)) {
            m.delete(area);
        } else {
            m.add(area);
        }
        this.setState(this.state);
    }
    checkboxMap(m: Set<string>, kv: string[]) {
        const [area, display] = kv;
        const onChange = () => this.toggleRadio(m, area);
        return (
            <div key={area} className="form-check">
                <input className="form-check-input" type="checkbox" checked={m.has(area)} onChange={onChange} />
                <label className="form-check-label"> {display} </label>
            </div>
        );
    }

    inputTitle(type: string, title: string, placeHolder: string, stateKey: key, errorMsg: string, disabled?: boolean, onBlur?: () => void) {
        const ks = stateKey instanceof Array ? stateKey : stateKey.includes('.') ? stateKey.split('.') : [stateKey];
        const converter = type === 'number' ? Number : Util.identity;
        return (
            <div
                style={{marginTop: '15px'}}
            >
                <label>{title} {errorMsg === '' ? '' : this.requiredStar}</label>
                <input
                    type={type}
                    placeholder={placeHolder}
                    value={Util.getIn(this.state, ks) || ''}
                    className="form-control"
                    onChange={(e: React.FormEvent<HTMLInputElement>) => this.assocState(stateKey, converter(e.currentTarget.value))}
                    disabled={disabled || false}
                    onBlur={onBlur}
                    autoComplete={this.disableAutocomplete ? 'new-password' : undefined}
                />
                {this.error(stateKey, errorMsg)}
            </div>
        );
    }

    inputTitleDebounce(type: string, title: string, placeHolder: string, stateKey: key, errorMsg: string, disabled?: boolean, onBlur?: () => void) {
        const ks = stateKey instanceof Array ? stateKey : stateKey.includes('.') ? stateKey.split('.') : [stateKey];
        const converter = type === 'number' ? Number : Util.identity;
        const onChange = (e: any) => this.assocState(stateKey, converter(e));
        return (
            <div
                style={{marginTop: '15px'}}
                className="m-2"
            >
                <label>{title} {errorMsg === '' ? '' : this.requiredStar}</label>
                <input
                    type={type}
                    placeholder={placeHolder}
                    defaultValue={Util.getIn(this.state, ks) || ''}
                    className="form-control"
                    onChange={Util.debounceEvent(onChange, 500)}
                    disabled={disabled || false}
                    onBlur={onBlur}
                    autoComplete={this.disableAutocomplete ? 'new-password' : undefined}
                />
                {this.error(stateKey, errorMsg)}
            </div>
        );
    }

    textInline(placeHolder: string, stateKey: string, labelWidth?: number) {
        const value = this.state[stateKey];
        const onChange = (e: any) => this.setState(Util.assoc(this.state, stateKey, e.currentTarget.value));
        labelWidth = labelWidth || 1;
        const inputWidth = 12 - labelWidth;
        return (
            <div className="form-group row">
                <label className={`col-sm-${labelWidth} col-form-label`}>{placeHolder}</label>
                <div className={`col-sm-${inputWidth}`}>
                    <input type="email" className="form-control" value={value} onChange={onChange} />
                </div>
            </div>
        );
    }

    input(type: string, placeHolder: string, stateKey: key, errorMsg: string, disabled?: boolean, onBlur?: () => void) {
        return this.inputTitle(type, placeHolder, placeHolder, stateKey, errorMsg, disabled, onBlur);
    }

    text(placeHolder: string, stateKey: key, errorMsg: string, disabled?: boolean, onBlur?: () => void) {
        return this.input('text', placeHolder, stateKey, errorMsg, disabled, onBlur);
    }

    email(placeHolder: string, stateKey: key, errorMsg: string, disabled?: boolean, onBlur?: () => void) {
        return this.input('email', placeHolder, stateKey, errorMsg, disabled, onBlur);
    }

    inputSimple(type: string, placeHolder: string, stateKey: string, onBlur?: () => void, conversion?: (s: string) => any) {
        const ks = stateKey.includes('.') ? stateKey.split('.') : [stateKey];
        const conversion2 = conversion || Util.identity;
        return (
            <input
                type={type}
                placeholder={placeHolder}
                value={Util.getIn(this.state, ks) || ''}
                className="form-control"
                onChange={(e: React.FormEvent<HTMLInputElement>) => this.assocState(stateKey, conversion2(e.currentTarget.value))}
                onBlur={onBlur}
                autoComplete={this.disableAutocomplete ? 'new-password' : undefined}
            />
        );
    }
    textSimple(placeHolder: string, stateKey: string, onBlur?: () => void) {
        return this.inputSimple('text', placeHolder, stateKey, onBlur);
    }
    numberSimple(placeHolder: string, stateKey: string, onBlur?: () => void) {
        return this.inputSimple('number', placeHolder, stateKey, onBlur, Number);
    }

    componentDidMount() {
        if (this.uploadcare) {
            this.uploadcare();
        }
    }

    profilePic(stateKey: string, f?: (newUrl: string) => void, centered?: boolean, showFavicon?: boolean) {
        let v = this.state[stateKey];
        if (v && typeof v !== 'string') {
            v = HomeClient.profilePic(v as any);
        }
        return (
            <div style={centered ? {margin: '0 auto', textAlign: 'center'} : undefined}>
                <div className="mb-2">
                    {showFavicon || v ? <img src={v || '/favicon.ico'}/> : '<Profile Pic>'}
                </div>
                <input
                    type="hidden"
                    role="uploadcare-uploader"
                    name={stateKey}
                    data-crop="300x400"
                    data-images-only="true"
                    ref={el => {
                        this.uploadcare = () => UploadCare.SingleWidget(el).onChange(async (e: any) => {
                            await e;
                            const newUrl = el && el.value;
                            if (f) {
                                f(newUrl as string);
                            }
                            this.assocState(stateKey, newUrl);
                        });
                    }}
                    style={{margin: '0 auto', textAlign: 'center'}}
                    className="btn btn-default btn-fixed mt-1"
                />
                <p>* Maximum image size is 1MB</p>
            </div>
        );
    }

    profilePicRO(stateKey: string, name: string) {
        let v = this.state[stateKey];
        if (v && typeof v !== 'string') {
            v = HomeClient.profilePic(v as any);
        }
        return (
            <div style={{margin: '0 auto', textAlign: 'center'}}>
                <h3>{name}</h3>
                <div className="mb-2">
                    <img src={v || '/favicon.ico'} />
                </div>
            </div>
        );
    }

    textAreaTitle(title: any, placeHolder: string, stateKey: key, errorMsg: string, onBlur?: () => void, rows?: number) {
        const ks = stateKey instanceof Array ? stateKey : stateKey.includes('.') ? stateKey.split('.') : [stateKey];
        return (
            <div
                style={{marginTop: '15px'}}
            >
                <label>{title} {errorMsg === '' ? '' : this.requiredStar}</label>
                <textarea
                    placeholder={placeHolder}
                    value={Util.getIn(this.state, ks) || ''}
                    className="form-control"
                    onChange={(e: SyntheticEvent<any>) => this.assocState(stateKey, e.currentTarget.value)}
                    onBlur={onBlur}
                    rows={rows}
                    autoComplete={this.disableAutocomplete ? 'new-password' : undefined}
                />
                {this.error(stateKey, errorMsg)}
            </div>
        );
    }

    textArea(placeHolder: string, stateKey: key, errorMsg: string, onBlur?: () => void, rows?: number) {
        return this.textAreaTitle(placeHolder, placeHolder, stateKey, errorMsg, onBlur, rows);
    }

    fileInput(placeHolder: string, stateKey: string, errorMsg: string, accept?: string) {
        return (
            <div
                style={{marginTop: '15px'}}
            >
                <label>{placeHolder} {errorMsg ? this.requiredStar : ''}</label>
                <input
                    type="file"
                    placeholder={placeHolder}
                    className="form-control"
                    onChange={(e: React.FormEvent<HTMLInputElement>) => this.assocState(stateKey, e.currentTarget.files ? e.currentTarget.files[0] : null)}
                    accept={accept}
                />
                {this.error(stateKey, errorMsg)}
            </div>
        );
    }

    file(label: string, k: string | (string | number)[], error?: string, onChange?: (f: B) => void) {
        const k2 = typeof k === 'string' ? [k] : k;
        const v = Util.getIn(this.state, k2);
        const fileData = v && v.key ? v as FileData : null;
        const searchParams = new URLSearchParams();
        if (fileData) {
            searchParams.set('key', fileData.key);
            searchParams.set('content-type', fileData['content-type']);
            searchParams.set('filename', fileData.filename);
            searchParams.set('size', fileData.size + '');
            searchParams.set('bucket-name', fileData['bucket-name']);
        }
        const fileIcon = mimeToIcon(fileData ? fileData['content-type'] : '');
        let fileInput: any;
        const setFileInput = (e: any) => fileInput = e;
        const fileChange = (e: any) => {
            const f = e.currentTarget.files ? e.currentTarget.files[0] : undefined;
            if (f) {
                const state = this.assocState(k, f);
                if (onChange) {
                    onChange(state);
                }
            }
        };
        const iconClick = fileData ? undefined : () => fileInput.click();
        return (
            <div
                style={{marginTop: '15px'}}
                className="m-2"
            >
                <label>{label}</label>
                {error ? <div className="mb-1">{this.error(k, error)}</div> : null}
                <div style={{fontSize: '3em'}}>
                    <a
                        href={fileData ? Util.backend + '/file?' + searchParams.toString() : undefined}
                        target="_blank"
                        onClick={iconClick}
                    >
                        {fileIcon}
                    </a>
                    <input type="file" style={{display: 'none'}} ref={setFileInput} onChange={fileChange}/>
                </div>
            </div>
        );
    }

    select(label: string, options: string[], stateKey: string, errorMsg: string, onChange?: (value: any) => void, ignoreDefault?: boolean) {
        const ks = stateKey.includes('.') ? stateKey.split('.') : [stateKey];
        return (
            <div
                style={{marginTop: '15px'}}
                className="m-2"
            >
                <label>{label} {errorMsg ? this.requiredStar : null}</label>
                <select
                    className="custom-select"
                    value={Util.getIn(this.state, ks) || ''}
                    onChange={(e: SyntheticEvent<any>) => onChange ? onChange(e.currentTarget.value) : this.assocState(stateKey, e.currentTarget.value)}
                >
                    {ignoreDefault ? null : <option value="">Please Select</option>}
                    {options.map(option => <option value={option} key={option}>{option}</option>)}
                </select>
                {this.error(stateKey, errorMsg)}
            </div>
        );
    }

    selectMap(label: string, options: object, stateKey: key, errorMsg: string) {
        const ks = keyToArr(stateKey);
        return (
            <div
                style={{marginTop: '15px'}}
                className="m-2"
            >
                <label>{label} {this.requiredStar}</label>
                <select
                    className="custom-select"
                    value={Util.getIn(this.state, ks) || ''}
                    onChange={(e: SyntheticEvent<any>) => this.assocState(stateKey, e.currentTarget.value)}
                >
                    <option value="">Please Select</option>
                    {Util.objMap(([k, v]) => <option value={k} key={k}>{v}</option>, options)}
                </select>
                {this.error(stateKey, errorMsg)}
            </div>
        );
    }

    binaryRadio(label: string, stateKey: string, f?: (b: B) => void) {
        const ks = stateKey.includes('.') ? stateKey.split('.') : [stateKey];
        const v = Util.getIn(this.state, ks);
        return (
            <div style={{marginTop: '15px'}}>
                <label>{label} {this.requiredStar}</label>
                <div className="m-2">
                    <input
                        type="radio"
                        name={stateKey}
                        checked={v === true}
                        onChange={() => (f || Util.identity)(this.assocState(stateKey, true))}
                    /> Yes
                </div>
                <div className="m-2">
                    <input
                        type="radio"
                        name={stateKey}
                        checked={v === false}
                        onChange={() => (f || Util.identity)(this.assocState(stateKey, false))}
                    /> No
                </div>
                {this.error(stateKey, 'Answer Question')}
            </div>
        );
    }

    radios(label: string, stateKey: string, values: any[], onClick?: (x: B) => void) {
        const ks = stateKey.includes('.') ? stateKey.split('.') : [stateKey];
        const v = Util.getIn(this.state, ks);
        return (
            <div>
                {label ? <label>{label}</label> : null}
                {values.map(value => (
                    <div className="form-check" key={value}>
                        <input
                            type="radio"
                            className="form-check-input"
                            name={stateKey}
                            checked={v === value}
                            onChange={() => onClick ? onClick(this.assocState(stateKey, value)) : this.assocState(stateKey, value)}
                        />
                        <label className="form-check-label">{value}</label>
                    </div>
                ))}
            </div>
        );
    }

    checkbox(label: string, stateKey: key, disabled?: boolean, f?: (x: B) => void) {
        const ks = keyToArr(stateKey);
        const onChange = f ? () => f(this.toggleState(stateKey)) : () => this.toggleState(stateKey);
        return (
            <div className="form-check">
                <input
                    type="checkbox"
                    className="form-check-input"
                    onChange={onChange}
                    checked={Util.getIn(this.state, ks) || false}
                    disabled={disabled}
                />
                <label className="form-check-label">{label}</label>
            </div>
        );
    }

    toggleState(k: key): B {
        const ks = keyToArr(k);
        return this.assocState(k, !Util.getIn(this.state, ks));
    }
}

export class FormModalCustomer<A, B extends object> extends Form<A, B> {
    inputTitle(type: string, title: string, placeHolder: string, stateKey: key, errorMsg: string, disabled?: boolean, onBlur?: () => void) {
        const ks = stateKey instanceof Array ? stateKey : stateKey.includes('.') ? stateKey.split('.') : [stateKey];
        const converter = type === 'number' ? Number : Util.identity;
        return (
            <div
                style={{marginTop: '15px'}}
            >
                <input
                    type={type}
                    placeholder={placeHolder}
                    value={Util.getIn(this.state, ks) || ''}
                    className="form-control"
                    onChange={(e: React.FormEvent<HTMLInputElement>) => this.assocState(stateKey, converter(e.currentTarget.value))}
                    disabled={disabled || false}
                    onBlur={onBlur}
                    autoComplete={this.disableAutocomplete ? 'new-password' : undefined}
                />
                {this.error(stateKey, errorMsg)}
            </div>
        );
    }
}

export class PersistentForm<A, B extends object> extends Form<A, B> {
    private stateKeys: string[];

    init(stateKeys: string[]) {
        this.stateKeys = stateKeys;
        for (const stateKey of stateKeys) {
            const v = sessionStorage.getItem(location.href + stateKey);
            if (v) {
                let parsed = JSON.parse(v);
                parsed = parsed[10] === 'T' && parsed[23] === 'Z' ? moment(parsed) : parsed;
                const ks = stateKey.includes('.') ? stateKey.split('.') : [stateKey];
                this.state = Util.assocIn(this.state, ks, parsed);
            }
        }
    }

    persist(k: string, v: any) {
        sessionStorage.setItem(location.href + k, JSON.stringify(v));
    }

    assocState(k: string, v: any, state?: B) {
        this.persist(k, v);
        return super.assocState(k, v, state);
    }

    clear() {
        for (const stateKey of this.stateKeys) {
            sessionStorage.removeItem(location.href + stateKey);
        }
    }
}



// WEBPACK FOOTER //
// ./src/widgets/Form.tsx